import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-pagetitle',
  template: `
<div class="row pb-3">
  <div class="col-12">
    <h2 *ngIf="isMediaSmallAndUp" [attr.class]="PageTitleClass" [innerHtml]="PageTitle"></h2>
    <p class="lead {{ PageLeadParaClass }}"><small [innerHtml]="PageLeadPara"></small></p>
    <hr aria-hidden="true" />
  </div>
</div>
`
})
export class PageTitleComponent {
  @Input()
  PageTitle: string;
  @Input()
  PageTitleClass: string | null = null;
  @Input()
  PageLeadPara: string;
  @Input()
  PageLeadParaClass: string | null = null;

  isMediaSmallAndUp: boolean;

  constructor() {
    this.evaluateMediaWidth();
  }

  @HostListener('window:resize')
  private evaluateMediaWidth(): void {
    this.isMediaSmallAndUp = window.innerWidth >= 576;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/pagetitle.component.ts